// extracted by mini-css-extract-plugin
export default {"Container":"AssignTicket_Container__FZxTh","HeaderButton":"AssignTicket_HeaderButton__rEMYn","CustomerDetails":"AssignTicket_CustomerDetails__y1Dff"};